import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import UserGuide from './UserGuide.js';
import UserGuideMob from './UserGuideMob.js';

class Header extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, false);
      window.dispatchEvent(event);
    }, 1000);
  }

  render() {
    const {
      closeModal,
      bookmarkPage,
      bookmarkURL,
      bookmarkTitle,
      bookmarkRel,
      toggleGuide,
      isGuideOpen,
      modalIsOpen,
      guide,
      showInstallBanner,
    } = this.props;

    return (
      <header role="banner" className="header">
        <div className="wrapper container">
          <Link className="icon header__logo-link" to="/">
            <img src="/img/logo.svg" className="header__logo" alt="Chubb Logo" />
          </Link>
          <aside className="header__helpers">
            <div className="header__btn-holder">
              <a
                href={!bookmarkURL ? '#' : bookmarkURL}
                title={!bookmarkTitle ? 'Bookmark Page' : bookmarkTitle}
                className="header__btn--bookmark"
                onClick={bookmarkPage}
                data-cta="Bookmark Page"
                rel={!bookmarkRel ? '' : bookmarkRel}
              >
                <img src="/img/bookmark.svg" alt="Bookmark" />
              </a>
              <button
                type="button"
                className={`header__btn ${isGuideOpen ? 'is-active' : ''}`}
                onClick={toggleGuide}
                data-cta="User Guide"
              >
                {guide}
              </button>
              
            </div>
            <Modal
              {...this.props}
              className="user-guide"
              isOpen={modalIsOpen}
              onAfterOpen={this.afterOpenModal}
              onRequestClose={this.closeShare}
              overlayRef={node => (this.overlayRef = node)}
              contentRef={node => (this.contentRef = node)}
            >
              <UserGuideMob closeModal={closeModal} />
            </Modal>
            {isGuideOpen && <UserGuide />}
          </aside>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js